<script>
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";

import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import sozlesmeyedavet from "./sozlesmeyedavet.vue";

export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Sözleşmeye Davet",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    sozlesmeyedavet,
  },
  data() {
    return {
      title: "Sözleşmeye Davet",
      FormData: {},
      satdosya: {},
      davet_firma: [],
      yazdirilanfirma: {},
      firma_kalemler: [],
      firma_fiyatlar: [],
      dosya_malzemeler: [],

      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "50",
        PageDataSize: "1",
      },
      TableData: [],
      gecersiz_teklifler: [],
      gecerli_teklifler: [],
      katilanfirmalar: [],
      dosyafirmalar: [],

      DataUpdate: "",
      AddEdit: "",
      SecilenFirmaid: "",
      OlcuBirimleri: [],
      excele_aktar: 0,
      pdf_aktar: 0,
      islem: 0,
      guncelle: 0,
      uri: "data:application/vnd.ms-excel;base64,",
      template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function(s, c) {
        return s.replace(/{(\w+)}/g, function(m, p) {
          return c[p];
        });
      },
    };
  },

  methods: {
    Get() {
      this.$emit("aktif_menu_title", "Sözleşmeye Davet");

      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        this.satdosya = res.Data;

        this.ActionsFilterGet({
          Service: "SatDosyaFirma",
          Page: this.Page,
          Filter: "&Dosyaid=" + this.satdosyaId,
        }).then((res) => {
          this.dosyafirmalar = res.Data;

          this.teklifkontrol();
        });
      });
    },

    teklifkontrol() {
      this.ActionsFilterGet({ Service: "satdosyazarfacmakontrol", Page: this.Page, Filter: "&Dosyaid=" + this.satdosyaId }).then((ressatdosyazarfacmakontrol) => {
        if (ressatdosyazarfacmakontrol) {
          this.gecersiz_teklifler = [];
          this.gecerli_teklifler = [];

          for (var j = 0; j < ressatdosyazarfacmakontrol.Data.length; j++) {
            let istenenbelgeler = JSON.parse(ressatdosyazarfacmakontrol.Data[j].Istenilenbelgeler);

            // alert(Object.values(istenenbelgeler)[0])
            let belge_kontrol = 0;

            for (var i = 0; i < Object.values(istenenbelgeler).length; i++) {
              if (Object.values(istenenbelgeler)[i] > 1) {
                belge_kontrol = 1;
              }
            }

            let zarffirma = "";
            for (i = 0; i < this.dosyafirmalar.length; i++) {
              if (this.dosyafirmalar[i].Id == ressatdosyazarfacmakontrol.Data[j].Dosyafirmaid) {
                zarffirma = this.dosyafirmalar[i].Firmaid;
              }
            }

            if (belge_kontrol == 0) {
              this.gecerli_teklifler.push(zarffirma);
            } else {
              this.gecersiz_teklifler.push(zarffirma);
            }
          }

          this.karar_tablosu();
        }
      });
    },

    gecerliteklifler() {
      this.ActionsFilterGet({
        Service: "SatDosyaFirma",
        Page: this.Page,
        Filter: "&Dosyaid=" + this.satdosyaId + "&Firmaturu=3",
      }).then((ressatdosyafirma) => {
        this.katilanfirmalar = ressatdosyafirma.Data.length;
        this.TableData = [];
        this.davet_firma = [];

        for (var i = 0; i < ressatdosyafirma.Data.length; i++) {
          let firmaid = ressatdosyafirma.Data[i].Firmaid;
          let dosyafirmaid = ressatdosyafirma.Data[i].Id;

          var varmi = this.gecerli_teklifler.indexOf(firmaid);
          if (varmi >= 0) {
            this.ActionsFilterGet({
              Service: "SatDosyaFirmaFiyat",
              Page: this.Page,
              Filter: "&Dosyaid=" + this.satdosyaId + "&Dosyafirmaid=" + dosyafirmaid + "&Fiyatturu=3",
            }).then((ressatdosyafirmafiyat) => {
              let toplam = 0;

              for (var j = 0; j < ressatdosyafirmafiyat.TotalCount; j++) {
                toplam = toplam + ressatdosyafirmafiyat.Data[j].Adet * ressatdosyafirmafiyat.Data[j].Birimfiyat;
              }

              this.ActionsGet({ Service: "OFirma/" + firmaid, Page: this.Page }).then((firma) => {
                if (this.satdosya.Teklifdegerlendirmeyontem == 1) {
                  this.TableData.push({ firmaid: firmaid, Firmaadi: firma.Data.Firmaadi, toplamfiyat: toplam });

                  if (i == ressatdosyafirma.TotalCount) {
                    this.TableData.sort(function(a, b) {
                      return a.toplamfiyat - b.toplamfiyat;
                    });

                    this.davet_firma = [];

                    for (var s = 0; s < 2; s++) {
                      this.davet_firma.push(this.TableData[s]);
                    }
                  }
                } else {
                  for (var k = 0; k < this.firma_kalemler.length; k++) {
                    if (firma.Data.Firmaadi == this.firma_kalemler[k].Firmaadi) {
                      this.TableData.push({ firmaid: firmaid, Firmaadi: firma.Data.Firmaadi, toplamfiyat: toplam });
                    }
                  }
                }
              });
            });
          }
        }
      });
    },

    karar_tablosu() {
      this.firma_kalemler = [];

      this.ActionsFilterGet({ Service: "SatDosyaMalzeme", Page: this.Page, Filter: "&Dosyaid=" + this.satdosyaId }).then((res) => {
        if (res) {
          this.dosya_malzemeler = res.Data;

          this.ActionsFilterGet({
            Service: "SatDosyaFirmaFiyat",
            Page: this.Page,
            Filter: "&Dosyaid=" + this.satdosyaId + "&Fiyatturu=3",
          }).then((fiyatlar) => {
            if (fiyatlar) {
              this.firma_fiyatlar = fiyatlar.Data;

              this.firma_fiyatlar.sort(function(a, b) {
                return a.Birimfiyat - b.Birimfiyat;
              });

              for (i = 0; i < this.dosya_malzemeler.length; i++) {
                var sayac = 0;

                for (k = 0; k < this.firma_fiyatlar.length; k++) {
                  if (this.firma_fiyatlar[k].Dosyamalzemeid == this.dosya_malzemeler[i].Id) {
                    sayac++;
                    if (sayac == 1) {
                      this.dosya_malzemeler[i].Firmaid = this.firma_fiyatlar[k].Firmaid;
                      this.dosya_malzemeler[i].Firmaadi = this.firma_fiyatlar[k].Firmaadi;
                      this.dosya_malzemeler[i].Birimfiyat = this.firma_fiyatlar[k].Birimfiyat;
                      this.dosya_malzemeler[i].Tutar = this.firma_fiyatlar[k].Birimfiyat * this.firma_fiyatlar[k].Adet;
                    }
                    if (sayac == 2) {
                      this.dosya_malzemeler[i].Firmaid2 = this.firma_fiyatlar[k].Firmaid;
                      this.dosya_malzemeler[i].Firmaadi2 = this.firma_fiyatlar[k].Firmaadi;
                      this.dosya_malzemeler[i].Birimfiyat2 = this.firma_fiyatlar[k].Birimfiyat;
                      this.dosya_malzemeler[i].Tutar2 = this.firma_fiyatlar[k].Birimfiyat * this.firma_fiyatlar[k].Adet;
                    }
                  }
                }
              }
            }

            let firmalar = [];

            for (var s = 0; s < this.dosya_malzemeler.length; s++) {
              var varmi = firmalar.indexOf(this.dosya_malzemeler[s].Firmaadi);
              if (varmi < 0) {
                firmalar.push(this.dosya_malzemeler[s].Firmaadi);
              }
            }

            for (var i = 0; i < firmalar.length; i++) {
              let kalemler = [];
              let tutar = 0;

              for (var k = 0; k < this.dosya_malzemeler.length; k++) {
                if (this.dosya_malzemeler[k].Firmaadi == firmalar[i]) {
                  kalemler.push(this.dosya_malzemeler[k].Sirano);

                  tutar = tutar + this.dosya_malzemeler[k].Tutar;
                }
              }

              this.firma_kalemler.push({ Firmaadi: firmalar[i], Kalemler: kalemler, Adet: kalemler.length, Tutar: tutar });
            }

            this.gecerliteklifler();
          });
        }
      });
    },

    SatDosyaUpdate() {
      this.Update("satdosya", this.satdosya);
    },
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
  },
};
</script>

<template>
  <Loader>
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-md-12">
                <div class="row mb-2">
                  <div class="col-sm-4">
                    <h5>Kesin Teminat Tarihi</h5>
                    <b-form-input v-model="satdosya.Kesinteminattarihi" @input="SatDosyaUpdate()" id="date" type="datetime-local"></b-form-input>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Firma Adı</th>
                        <th width="100"><center>İşlem</center></th>
                      </tr>
                    </thead>
                    <tbody v-show="satdosya.Teklifdegerlendirmeyontem == 1">
                      <tr v-for="Data in davet_firma" :key="Data.firmaid">
                        <th scope="row">{{ Data.Firmaadi }}</th>
                        <td>
                          <center><i class="fas fa-print" v-tooltip="'Yazdır'" v-b-modal.sozlesmeyedavet @click="(guncelle = guncelle + 1), (SecilenFirmaid = Data)"></i>&nbsp;&nbsp;</center>
                        </td>
                      </tr>
                    </tbody>

                    <tbody v-show="satdosya.Teklifdegerlendirmeyontem == 2">
                      <tr v-for="Data in TableData" :key="Data.firmaid">
                        <th scope="row">{{ Data.Firmaadi }}</th>
                        <td style="width: 85px; text-align: center;">
                          <b-button-group>
                            <b-button @click="(guncelle = guncelle + 1), (SecilenFirmaid = Data)" v-b-modal.sozlesmeyedavet v-tooltip="'Yazdır'" variant="primary">
                              <i class="far fa-print"></i>
                            </b-button>
                          </b-button-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <sozlesmeyedavet :satdosyaId="satdosyaId" :SecilenFirmaid="SecilenFirmaid" v-show="guncelle > 0" :guncelle="guncelle" />
  </Loader>
</template>
